import { Grid } from '@mui/material';
import React from 'react';
import DiologMenu from './DiologMenu';

const IntegrateDiolog = () => {
    return (
        <>
            <Grid item xs={12} md={8} lg={9} className="card-content update-profile-card-content integrate-diolog">
                <Grid container direction="column" rowSpacing={3}>
                    <DiologMenu />
                </Grid>
            </Grid>
        </>
    );
};

export default IntegrateDiolog;
